import "./ClientPageContainer.scss";

import { CreateClientModal } from "components/Modals";
import { SECTION } from "constants/SettingsConstants";
import { useEffect, useMemo } from "react";
import { setCurrentSection, setShowAddModal } from "reducers/main";
import { useDispatch, useSelector } from "utils/redux";

type RREContainerPropTypes = {
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

const ClientPageContainer = ({
  header,
  footer,
  children,
}: RREContainerPropTypes) => {
  const dispatch = useDispatch();
  const showAddModal = useSelector((state) => state.main.showAddModal);

  useEffect(() => {
    dispatch(setCurrentSection(SECTION.CLIENT));
  }, [dispatch]);

  const modal = useMemo(() => {
    return (
      <CreateClientModal
        isOpen={showAddModal}
        onClose={() => {
          dispatch(setShowAddModal(false));
        }}
      />
    );
  }, [showAddModal, dispatch]);

  return (
    <>
      {modal}
      <div className="ClientPageContainer">
        {header && <div className="ClientPageContainer__Header">{header}</div>}
        {children}
        {footer && <div className="ClientPageContainer__Footer">{footer}</div>}
      </div>
    </>
  );
};

export default ClientPageContainer;
